import Vue from 'vue'

export async function getEmpleados(context, [access_token, showload]) {
    try {
       
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'GET',
            url: '/trabajadores',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            

        })
        context.commit('emp/setEmpleados', response.data.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateEmpleado(context, [access_token, emp]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/trabajadores/' + emp.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                empleado: emp,
               
            }
        })
        if (response.status == 200) {
            context.commit('emp/actListEmpleados', response.data, { root: true })
        }
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function changePassword(context, [access_token, idemp, antpassword, newpassword, confirmpassword]) {
    
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/trabajadorchangepassword',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id_empleado: idemp,
                antpassword: antpassword,
                newpassword: newpassword,
                confirmpassword: confirmpassword,
            }
        })
      
        context.commit('emp/setMessageContrasena', response.data.message, { root: true })
       } catch (e) {
      
      //  context.commit('emp/empleadosError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function createEmpleado(context, [access_token, emp, pass]) {
    try {
        
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/trabajadores',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                empleado: emp,
                password: pass
                
            }
        })
       
       
    } catch (e) {
      
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function deleteEmpleado(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/trabajadordelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
      
        if (response.status == 201) {
            context.commit('emp/actDeleteListEmpleados', id, { root: true })
        }
       
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}












